import { createActions, createReducer } from 'reduxsauce'

import ConsultaLicitacaoService from '../../servicos/ConsultaLicitacaoService'

/**
 * Action types & creators
 */
export const { Types, Creators } = createActions({
    buscaConsultaLicitacaoInicio: [],
    buscaConsultaLicitacaoErro: ['erro'],
    buscaConsultaLicitacaoSucesso: ['consultaLicitacao'],
    limpar: [],
    setConsultaLicitacaoEstadoDT: ['estado'],
})

const INITIAL_STATE = {
    carregando: false,
    erro: null,
    lista: [],
    dataSincronizacaoDados: null,
    estadoDT: {},
}

// Ação para busca completa
Creators.buscaConsultaLicitacao = filtro => {
    return dispatch => {
        dispatch(Creators.buscaConsultaLicitacaoInicio())
        let serv = new ConsultaLicitacaoService()
        return serv
            .consultar(filtro)
            .then(response => dispatch(Creators.buscaConsultaLicitacaoSucesso(response.data)))
            .catch(error => dispatch(Creators.buscaConsultaLicitacaoErro(error)))
    }
}

Creators.buscaConsultaLicitacaoMP = filtro => {
    return dispatch => {
        dispatch(Creators.buscaConsultaLicitacaoInicio())
        let serv = new ConsultaLicitacaoService()
        return serv
            .consultarLicitacaoMP(filtro)
            .then(response => dispatch(Creators.buscaConsultaLicitacaoSucesso(response.data)))
            .catch(error => dispatch(Creators.buscaConsultaLicitacaoErro(error)))
    }
}

Creators.buscaRespostasImpugnacoesPedidosMP = filtro => {
    return dispatch => {
        dispatch(Creators.buscaConsultaLicitacaoInicio())
        let serv = new ConsultaLicitacaoService()
        return serv
            .respostasImpugnacoesPedidosMP(filtro)
            .then(response => dispatch(Creators.buscaConsultaLicitacaoSucesso(response.data)))
            .catch(error => dispatch(Creators.buscaConsultaLicitacaoErro(error)))
    }
}

Creators.buscaDispensasInexigibilidadesMP = filtro => {
    return dispatch => {
        dispatch(Creators.buscaConsultaLicitacaoInicio())
        let serv = new ConsultaLicitacaoService()
        return serv
            .dispensasInexigibilidadesMP(filtro)
            .then(response => dispatch(Creators.buscaConsultaLicitacaoSucesso(response.data)))
            .catch(error => dispatch(Creators.buscaConsultaLicitacaoErro(error)))
    }
}

Creators.buscaInteresseContratacaoDispensaMP = filtro => {
    return dispatch => {
        dispatch(Creators.buscaConsultaLicitacaoInicio())
        let serv = new ConsultaLicitacaoService()
        return serv
            .interesseContratacaoDispensaMP(filtro)
            .then(response => dispatch(Creators.buscaConsultaLicitacaoSucesso(response.data)))
            .catch(error => dispatch(Creators.buscaConsultaLicitacaoErro(error)))
    }
}

Creators.buscaEditalChamamentoInteressadosMP = filtro => {
    return dispatch => {
        dispatch(Creators.buscaConsultaLicitacaoInicio())
        let serv = new ConsultaLicitacaoService()
        return serv
            .editalChamamentoInteressadosMP(filtro)
            .then(response => dispatch(Creators.buscaConsultaLicitacaoSucesso(response.data)))
            .catch(error => dispatch(Creators.buscaConsultaLicitacaoErro(error)))
    }
}

Creators.buscaRolLicitantesMP = filtro => {
    return dispatch => {
        dispatch(Creators.buscaConsultaLicitacaoInicio())
        let serv = new ConsultaLicitacaoService()
        return serv
            .rolLicitantesMP(filtro)
            .then(response => dispatch(Creators.buscaConsultaLicitacaoSucesso(response.data)))
            .catch(error => dispatch(Creators.buscaConsultaLicitacaoErro(error)))
    }
}

const buscaConsultaLicitacaoInicio = (state = INITIAL_STATE, action) => ({ ...state, carregando: true, erro: null })

const buscaConsultaLicitacaoErro = (state = INITIAL_STATE, action) => ({ ...state, erro: action.erro, carregando: false })

const buscaConsultaLicitacaoSucesso = (state = INITIAL_STATE, action) => {
    return { ...state, lista: action.consultaLicitacao.resultado, dataSincronizacaoDados: action.consultaLicitacao.dataSincronizacaoDados, carregando: false }
}

const limpar = (state = INITIAL_STATE, action) => {
    return INITIAL_STATE
}

const setConsultaLicitacaoEstadoDT = (state = INITIAL_STATE, action) => {
    return { ...state, estadoDT: action.estado }
}

/**
 * Reducer
 */
export default createReducer(INITIAL_STATE, {
    [Types.BUSCA_CONSULTA_LICITACAO_INICIO]: buscaConsultaLicitacaoInicio,
    [Types.BUSCA_CONSULTA_LICITACAO_ERRO]: buscaConsultaLicitacaoErro,
    [Types.BUSCA_CONSULTA_LICITACAO_SUCESSO]: buscaConsultaLicitacaoSucesso,
    [Types.LIMPAR]: limpar,
    [Types.SET_CONSULTA_LICITACAO_ESTADO_DT]: setConsultaLicitacaoEstadoDT,
})
